// extracted by mini-css-extract-plugin
export default {"authorization":"Authorization_authorization__9bxbT","authorization__content":"Authorization_authorization__content__nS34B"};